import React, { useEffect } from 'react';

import { ReceivedSoundArrType } from './QueuePanel';
import { baseSoundURL } from '../../../config';

interface SoundPlayerProps {
  soundsData?: ReceivedSoundArrType | null;
  updateSoundStatus: (id: number | null) => void;
  setIsSoundPlaying: (status: boolean) => void;
}

function playMusicSequentially(musicArr: string[], setIsSoundPlaying: (status: boolean) => void) {
  let currentTrackIndex = 0;

  const playNextTrack = () => {
    if (currentTrackIndex >= musicArr.length) {
      setIsSoundPlaying(false);
      return;
    }

    const trackPath = musicArr[currentTrackIndex];
    const audio = new Audio(`${baseSoundURL}${trackPath}`);

    audio
      .play()
      .catch((e) => {
        console.error(e);
      });

    audio.onended = () => {
      currentTrackIndex++; // Переходим к следующему треку
      playNextTrack(); // Рекурсивно вызываем функцию для воспроизведения следующего трека
    };
  };

  playNextTrack(); // Начинаем воспроизведение с первого трека
}

const SoundPlayer: React.FC<SoundPlayerProps> = ({
  soundsData,
  updateSoundStatus,
  setIsSoundPlaying
}) => {
  useEffect(() => {
    if (!soundsData?.sounds?.length) return;
    const playSoundsArr: string[] = [];
    soundsData.sounds.reverse().map((e, idx) => {
      playSoundsArr.push(...e);
      updateSoundStatus(soundsData.receivedSoundsIds?.[idx] ?? null);
    });
    if (playSoundsArr.length) {
      setIsSoundPlaying(true);
      playMusicSequentially(playSoundsArr, setIsSoundPlaying);
    }
  }, [soundsData]);

  return null;
};

export default SoundPlayer;
